import type { GQL_ID } from '@@partner:types:graphql'

import React from 'react'
import { normalizePhoneNumber, formatPhone } from '@@partner:helpers/util'
import { useFetchSingleCustomer } from '@@partner:graphql/query/allCustomers/singleCustomer.gql'
import { useParams, Link, generatePath } from 'react-router-dom'

import { Tag, Button, FlexboxGrid } from 'rsuite'
import GraphQLCommonErrorDisplay from '@components/common/GraphQLCommonErrorDisplay'
import AppLoader from '@components/common/AppLoader'
import LegacyPhoneIcon from '@rsuite/icons/legacy/Phone'
import Email from '@rsuite/icons/legacy/AddressBook'

import { ROUTE_CUSTOMERS_VIEW_CUSTOMER } from '@@partner:config/routes'

export interface OrderCustomerProps {
  customer_id?: GQL_ID
}

export default function CustomerCard ({ customer_id }: OrderCustomerProps) {
  const { brandSlug } = useParams<any>()
  const { data, loading, error } = useFetchSingleCustomer({
    id: customer_id
  })

  const customer = data?.customer

  if (loading) {
    return <AppLoader.RowsWithText content="Загружаем заказ" />
  }

  if (error) {
    return <GraphQLCommonErrorDisplay error={error} />
  }

  if (!customer) {
    return <p>Customer not found!</p>
  }

  return (
    <>
      {customer && (
        <div>
          <div className="ViewOrder__First">
            {customer.fullName}
          </div>
          <div className="ViewOrder__Info__Row">
            {customer.ordersCount} заказов
          </div>
          
          <FlexboxGrid align='middle' justify='space-between'>
            <FlexboxGrid.Item>
              <div>
                <strong>Контакты:</strong>
              </div>
              <div>
                <a href={`mailto:${customer.receipt_email}`}>
                  <Email /> {customer.receipt_email}
                </a>
              </div>
              <div>
                <a href={`tel:${normalizePhoneNumber(customer.phone)}`}>
                  <LegacyPhoneIcon /> {formatPhone(customer.phone)}
                </a>
              </div>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item>
              <Button
                color="green"
                appearance="primary"
                as={Link}
                to={generatePath(ROUTE_CUSTOMERS_VIEW_CUSTOMER, {
                  brandSlug,
                  customerId: customer.id
                })}
                size="xs"
              >
                Просмотр
              </Button>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </div>
      )}
    </>
  )
}
